import * as Types from "../actions/action.types"
import * as Models from "../models/index"
import * as Toolbox from "./../infrastructure/toolbox"

export const defaultState = {
    oldPassword: "",
    password: "",
    confirmPassword: "",
    resultMessage: null as string,
    secretQuestions: [] as Models.CheckSecretAnswersByUserName_Response_Client[],
    visibleSecretQuestions: false,
    answers: [{answerId: Toolbox.newGUID()},
              {answerId: Toolbox.newGUID()},
              {answerId: Toolbox.newGUID()} ] as Models.SecretAnswer[]
}

export type ReducerState = typeof defaultState;
export const reducer = (state = defaultState, action: any): ReducerState => {
    switch (action.type) {
        case Types.PWD_UPDATE_CONFIRM_PASSWORD:
            return {
                ...state,
                confirmPassword: action.payload,
                resultMessage: null
            }
        case Types.PWD_UPDATE_PASSWORD:
            return {
                ...state,
                password: action.payload,
                resultMessage: null
            }
        case Types.PWD_EXPIRED_UPDATE_OLD_PASSWORD:
            return {
                ...state,
                oldPassword: action.payload,
                resultMessage: null
            }
        case Types.PWD_SET_DEFAULT:
            return {
                ...state,
                password: "",
                confirmPassword: "",
                oldPassword: "",
                secretQuestions: [],
                answers: [{answerId: Toolbox.newGUID(), questionId: null, answerText: ""},
                          {answerId: Toolbox.newGUID(), questionId: null, answerText: ""},
                          {answerId: Toolbox.newGUID(), questionId: null, answerText: ""}],
                visibleSecretQuestions: false
            }
        case Types.SET_SECRET_QUESTIONS:
            return {
                ...state,
                secretQuestions: action.payload
            }
        case Types.CHANGE_VISIBLE_SELECT_SECRET_QUESTION:
            return {
                ...state,
                visibleSecretQuestions: true
            }
        case Types.PWD_UPDATE_SECRET_ANSWERS: {
            let answersResult = [].concat(state.answers);
            
            answersResult.forEach(el =>{
                if(el.answerId === action.payload.answerId) {
                    el.questionId = action.payload.questionId
                }
            })
            
            return {
                ...state,
                answers: answersResult
            }
        }
        case Types.PWD_UPDATE_SECRET_ANSWER_TEXT: {
            let answersResult = state.answers.slice();
            answersResult.forEach(el =>{
                if(el.answerId === action.payload.answerId) {
                    el.answerText = action.payload.answerText
                }
            })
            
            return {
                ...state,
                answers: answersResult
            }
        }
        default:
            return state;
    }
}